module.exports = __webpack_public_path__ + "static/media/AppLogo.fcb208a5.svg";